import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import flagsmith from 'flagsmith'
import {FlagsmithProvider} from 'flagsmith/react'
import "./i18n";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://dc4e7cca8885aa9ab8d983cedf132142@o4509044913995776.ingest.us.sentry.io/4509044916617216",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    Sentry.feedbackIntegration({
      colorScheme: "system",
      isEmailRequired: true,
      isNameRequired: true,
    }),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <FlagsmithProvider options={{
      environmentID: process.env.REACT_APP_FLAGSMITH_ENVIRONMENT_ID || '',
      }} flagsmith={flagsmith}>
      <App />
    </FlagsmithProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
